import Prism from 'prismjs'

import 'prismjs/components/prism-css'
import 'prismjs/components/prism-graphql'
import 'prismjs/components/prism-yaml'
import 'prismjs/components/prism-typescript'
import 'prismjs/components/prism-go'
import 'prismjs/components/prism-jsx'
import 'prismjs/components/prism-sql'
import './prism-svelte'
import './prisma-lang'
import './prism-yml'

import 'prismjs/plugins/line-numbers/prism-line-numbers'

import 'prismjs/themes/prism.css'
import './prism.css'

Prism.languages.json = Prism.languages.jsx

Prism.languages.bash = { line: /^.*\n/gm }
Prism.languages.shell = Prism.languages.bash

export default Prism
